import { render, staticRenderFns } from "./DataUpgrade.vue?vue&type=template&id=20a65dad&scoped=true&"
import script from "./DataUpgrade.vue?vue&type=script&lang=js&"
export * from "./DataUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./DataUpgrade.vue?vue&type=style&index=0&id=20a65dad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a65dad",
  null
  
)

export default component.exports